var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("h3", { staticStyle: { "margin-left": "30px" } }, [
        _vm._v("\n    Главная страница\n  ")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }